import { useState } from 'react'

import * as S from './styles'
import { useDepositions } from './useDepositions'
import { Testimonial, Text } from '@/components'
import { Button } from '@/components/button'
import { CasePagination } from '@/components/casePagination'

export type DepositionsProps = {
  handleScrollToElement: () => void
}
export const Depositions: React.FC<DepositionsProps> = ({
  handleScrollToElement,
}) => {
  const [caseIndex, setCaseIndex] = useState(0)
  const { fontSizes, depositionsData } = useDepositions()

  if (!depositionsData.casesData.length) return null

  const cases = depositionsData.casesData[caseIndex]
  return (
    <S.DepositionsContainer>
      <Text size={fontSizes.title} align="center">
        {depositionsData.title}
      </Text>

      <div className="pagination-container">
        <Testimonial
          authorPicture={cases?.authorAvatar}
          authorName={cases?.authorName}
          authorRole={cases?.authorRole}
          description={cases?.description}
          darkMode
        />
        <CasePagination
          length={depositionsData.casesData.length}
          setIndex={setCaseIndex}
          index={caseIndex}
          slug={cases.slug}
          className="deposition-pagination"
        />
      </div>
      <Button onClick={handleScrollToElement} className="button-depositions">
        {depositionsData.buttonText}
      </Button>
    </S.DepositionsContainer>
  )
}
